import {
  Dropdown,
  Button,
  Select,
  Menu,
  Segmented,
  Input,
  Spin,
  Form,
  DatePicker,
  Typography,
  Card,
  Col,
  Row,
  Steps,
  InputNumber,
  Radio,
} from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import React, { useEffect, useRef, useState } from "react";

import TextArea from "antd/es/input/TextArea";
import moment from "moment";

const VIPEventModal = ({
  open,
  handleClose,
  style,
  edit,
  form,
  onFinish,
  onFinishFailed,
}) => {
  //   console.log(edit);

  const inputRef = useRef(null);
  const { Title } = Typography;
  useEffect(() => {
    if (edit) {
      // convert top-level dates and lots' dates to moments
      const values = {
        ...edit,
        eventDate: edit?.eventDate ? moment(edit.eventDate) : null,
        endDate: edit?.endDate ? moment(edit.endDate) : null,
        startDate: edit?.startDate ? moment(edit.startDate) : null,
      };

      if (Array.isArray(edit.lots)) {
        values.lots = edit.lots.map((l) => ({
          ...l,
          lotStartDate: l.lotStartDate ? moment(l.lotStartDate) : null,
          lotRegistrationEndDate: l.lotRegistrationEndDate
            ? moment(l.lotRegistrationEndDate)
            : null,
        }));
      }

      form.setFieldsValue(values);
    }
  }, [edit, open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Title level={4} style={{ display: "flex", justifyContent: "center" }}>
          Event Details
        </Title>
        <hr />
        <Form
          form={form}
          name="basic"
          className="custom-form"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        // onValuesChange={handleValuesChange}
        >
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="eventName"
            label="Event Name"
            rules={[
              {
                required: true,
                message: "Enter event name!",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Enter event name"
              style={{
                border: '1px solid #d9d9d9', // Set a border to avoid global CSS issues
                borderRadius: '4px', // Rounded corners
                padding: '4px', // Padding for better spacing
                width: '100%', // Full width
                boxShadow: 'none', // Remove any shadow
                height: '40px', // Fixed height
              }}
            />
          </Form.Item>
          <Form.Item
            name="eventDate"
            label="Event Date"
            rules={[{ required: true, message: "Please select a event date!" }]}
          >
            <DatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="code"
            label="Code"
            rules={[
              {
                required: true,
                message: "Enter event code!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter event code"
              style={{
                border: '1px solid #d9d9d9', // Set a border to avoid global CSS issues
                borderRadius: '4px', // Rounded corners
                padding: '4px', // Padding for better spacing
                width: '100%', // Full width
                boxShadow: 'none', // Remove any shadow
                height: '40px', // Fixed height
              }}
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="registrationCount"
            label="Registration Count"
            rules={[
              {
                required: true,
                message: "Enter event registration count!",
              },
            ]}
          >
            <InputNumber
              size="large"
              style={{ width: "100%" }}
              placeholder="Enter event registration count"
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="eventLimit"
            label="Registration Count Limit"
            rules={[
              {
                required: true,
                message: "Enter event registration count limit!",
              },
            ]}
          >
            <InputNumber
              size="large"
              style={{ width: "100%" }}
              placeholder="Enter event registration count limit"
            />
          </Form.Item>
          <Form.Item
            style={{ marginBottom: "10px" }}
            name="attendance"
            label="Attendance Count"
          // rules={[
          //   {
          //     required: true,
          //     message: "Enter event attendance count!",
          //   },
          // ]}
          >
            <InputNumber
              size="large"
              style={{ width: "100%" }}
              placeholder="Enter event attendance count"
            />
          </Form.Item>
          <Form.Item
            name="startDate"
            label="Event Start Date"
            rules={[
              { required: true, message: "Please select a event start date!" },
            ]}
          >
            <DatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="endDate"
            label="Event End Date"
            rules={[
              { required: true, message: "Please select a event end date!" },
            ]}
          >
            <DatePicker
              getPopupContainer={(trigger) => trigger.parentNode}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>

          {/* Added: Lots list - per-lot start and registration end dates */}
          <Form.List name="lots">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <div
                    key={key}
                    style={{
                      border: "1px dashed #d9d9d9",
                      padding: 12,
                      marginBottom: 12,
                      position: "relative",
                      borderRadius: 4,
                    }}
                  >
                    <Row gutter={12}>
                      <Col span={6}>
                        <Form.Item
                          {...restField}
                          name={[name, "lotNumber"]}
                          fieldKey={[fieldKey, "lotNumber"]}
                          label="Lot Number"
                          rules={[{ required: true, message: "Enter lot number" }]}
                        >
                          <InputNumber style={{ width: "100%" }} min={1} />
                        </Form.Item>
                      </Col>
                      <Col span={9}>
                        <Form.Item
                          {...restField}
                          name={[name, "lotStartDate"]}
                          fieldKey={[fieldKey, "lotStartDate"]}
                          label="Lot Start Date"
                          rules={[{ required: true, message: "Select lot start date" }]}
                        >
                          <DatePicker
                            getPopupContainer={(trigger) => trigger.parentNode}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={9}>
                        <Form.Item
                          {...restField}
                          name={[name, "lotRegistrationEndDate"]}
                          fieldKey={[fieldKey, "lotRegistrationEndDate"]}
                          label="Lot Registration End Date"
                          rules={[{ required: true, message: "Select registration end date" }]}
                        >
                          <DatePicker
                            getPopupContainer={(trigger) => trigger.parentNode}
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <MinusCircleOutlined
                      onClick={() => remove(name)}
                      style={{ position: "absolute", top: 8, right: 8, fontSize: 18, color: '#ff4d4f', cursor: 'pointer' }}
                    />
                  </div>
                ))}

                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add({ lotNumber: null, lotStartDate: null, lotRegistrationEndDate: null })}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Lot
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>

          <Form.Item
            name="active"
            label="Status"
            rules={[{ required: true, message: "Please select a status!" }]}
          >
            <Radio.Group>
              <Radio value={true}>Active</Radio>
              <Radio value={false}>Deactive</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            className="modal-buttons"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button type="primary" htmlType="submit">
              {edit ? "Update" : "Submit"}
            </Button>
            &nbsp;
            &nbsp;
            <Button onClick={handleClose}>Cancel</Button>
          </Form.Item>
        </Form>
      </Box>
    </Modal>
  );
};

export default VIPEventModal;
